import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import { useSelector } from 'react-redux'; 

const MSMEWhyCertificate = () => {
  const authState = useSelector(state => state.authReducer);
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();

  return (
    <section id="whycertificate" className="py-4 px-6 md:px-20 bg-gradient-to-r from-teal-600 to-teal-800 text-white">
        <h2 className="text-xl font-bold text-center mb-2 text-white">Why SAKSHAM MSME Certificate?</h2>
        <div className="max-w-xl mx-auto text-center text-white">
          <p className="text-m mb-6">
            Empowered with knowledge, equipped with tools—this certificate honors the spirit of self-reliance and excellence in India’s MSME journey. Through aptitude, action, and awareness, we build a SAKSHAM Bharat.
          </p>
          <p className="text-m">
            The SAKSHAM MSME Certificate is an optional recognition awarded to eligible subscribers of the SAKSHAM Bharat Startup Kit who successfully clear the SAKSHAM MSME Aptitude Test. MSMEs can proudly display it alongside their Vision, Mission, and Quality Policy, while buyers and financial institutions may request it as a mark of credibility and preparedness.
          </p>
        </div>
    </section>
  );
};

export default MSMEWhyCertificate;
